import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteFreightClaimAttachmentsCall,
  postApproveOrRejectInventoryAdjustment,
  uploadFreightClaimAttachmentsCall
} from "src/api/sp";
import { resetStore } from "src/store/actions";
import { AttachmentsInitialState, UploadAttachmentFile } from "./interface";

export const inventoryAdjustmentApprover = createAsyncThunk(
  "inventoryAdjustmentApprover",
  (payload: any) => postApproveOrRejectInventoryAdjustment(payload)
);

export const uploadApproverAttachments = createAsyncThunk(
  "uploadApproverAttachments",
  (fcUploadAttachmentPayload: UploadAttachmentFile) =>
    uploadFreightClaimAttachmentsCall(fcUploadAttachmentPayload)
);

export const deleteApproverAttachments = createAsyncThunk(
  "deleteFreightClaimAttachments",
  (filePath: string) => {
    deleteFreightClaimAttachmentsCall(filePath);
  }
);

export const initialState: any = {
  loading: false,
  notes: "",
  attachments: [],
  deletedAttachmentPaths: [],
  newApproverAttachmentsCount: 0
};

const inventoryAdjustmentApproverSlice = createSlice({
  name: "inventoryAdjustmentApprover",
  initialState,
  reducers: {
    updateApproverAttachment(
      state: AttachmentsInitialState,
      action: {
        payload: { fileName: string; fileURL: string; fileType: string };
      }
    ) {
      state.attachments.push(action.payload);
    },
    setApproverAttachment(
      state: AttachmentsInitialState,
      action: {
        payload: { fileName: string; fileURL: string; fileType: string }[];
      }
    ) {
      state.attachments = action.payload;
    },
    removeApproverAttachment(
      state: AttachmentsInitialState,
      action: { payload: number }
    ) {
      const filterAttachments = state.attachments.filter(
        (_item: any, itemIndex: number) => itemIndex !== action?.payload
      );
      state.attachments = filterAttachments;
      state.newApproverAttachmentsCount -= 1;
    },
    updateApproverNotes(state: any, action: any) {
      const notes = action.payload;
      state.notes = notes;
    },
    reset() {
      return initialState;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(resetStore, (state, action) => {
        return initialState;
      })
      .addCase(inventoryAdjustmentApprover.pending, (state) => {
        state.loading = true;
      })
      .addCase(inventoryAdjustmentApprover.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(inventoryAdjustmentApprover.rejected, (state) => {
        state.loading = false;
      })
      .addCase(uploadApproverAttachments.pending, (state) => {
        state.uploadAttachmentLoading = true;
      })
      .addCase(uploadApproverAttachments.fulfilled, (state) => {
        state.uploadAttachmentLoading = false;
        state.newApproverAttachmentsCount += 1;
      })
      .addCase(uploadApproverAttachments.rejected, (state) => {
        state.uploadAttachmentLoading = false;
      });
  }
});

export const {
  updateApproverNotes,
  updateApproverAttachment,
  setApproverAttachment,
  removeApproverAttachment,
  reset
} = inventoryAdjustmentApproverSlice.actions;

export const selectApproverAttachments = (state: any) =>
  state.inventoryAdjustmentApprover?.attachments;

export const selectBlockNavigation = (state: any) =>
  state.inventoryAdjustmentApprover.blockNavigation;

export const selectApproverNotes = (state: any) =>
  state.inventoryAdjustmentApprover?.notes;

export const selectLoading = (state: any) =>
  state.inventoryAdjustmentApprover.loading;

export const selectNewApproverAttachmentsCount = (state: any) =>
  state.inventoryAdjustmentApprover.newApproverAttachmentsCount;

export default inventoryAdjustmentApproverSlice.reducer;
